// 공장 관리 모달
import React, { useState } from "react";
import {
  createFactory,
  updateFactory,
  deleteFactory,
} from "../../api/users/companies";
import FactoryRow from "./FactoryRow"

const FactoryModal = ({ company, factoryList, onClose, reloadFactoryList }) => {
  const [factoryEditId, setFactoryEditId] = useState(null);
  const [factoryEditData, setFactoryEditData] = useState({
    name: "",
    address: "",
    detail_address: "",
    extra_address: "",
  });
  const [factoryNew, setFactoryNew] = useState({
    name: "",
    address: "",
    detail_address: "",
    extra_address: "",
  });

  const onChangeFactoryNew = (key) => (e) =>
    setFactoryNew((p) => ({ ...p, [key]: e.target.value }));
  const onChangeFactoryEdit = (key) => (e) =>
    setFactoryEditData((p) => ({ ...p, [key]: e.target.value }));

  // FactoryRow용 onChange 함수 (idx, key, value 형태)
  const onChangeFactoryNewForRow = (idx, key, value) => {
    setFactoryNew((prev) => ({ ...prev, [key]: value }));
  };

  const addFactoryInModal = async () => {
    if (!company?.id) return;
    if (!factoryNew.name) {
      alert("공장명을 입력하세요.");
      return;
    }
    try {
      await createFactory({
        company: company.id,
        name: factoryNew.name,
        address: factoryNew.address || "",
        detail_address: factoryNew.detail_address || "",
        extra_address: factoryNew.extra_address || "",
      });
      setFactoryNew({ name: "", address: "", detail_address: "", extra_address: "" });
      await reloadFactoryList();
    } catch (e) {
      console.error("공장 추가 실패:", e?.response?.data || e);
      alert("공장 추가 실패\n" + JSON.stringify(e?.response?.data || {}, null, 2));
    }
  };

  const startFactoryEdit = (row) => {
    setFactoryEditId(row.id);
    setFactoryEditData({
      name: row.name ?? "",
      address: row.address ?? "",
      detail_address: row.detail_address ?? "",
      extra_address: row.extra_address ?? "",
    });

    setFactoryNew({
      name: row.name ?? "",
      address: row.address ?? "",
      detail_address: row.detail_address ?? "",
      extra_address: row.extra_address ?? "",
    });
  };

  const saveFactoryEdit = async (id) => {
    try {
      await updateFactory(id, { ...factoryEditData, company: company.id });
      setFactoryEditId(null);
      await reloadFactoryList();
    } catch (e) {
      console.error("공장 수정 실패:", e?.response?.data || e);
      alert("공장 수정 실패\n" + JSON.stringify(e?.response?.data || {}, null, 2));
    }
  };

  const removeFactory = async (id) => {
    if (!window.confirm("공장을 삭제하시겠습니까?")) return;
    try {
      await deleteFactory(id);
      await reloadFactoryList();
    } catch (e) {
      console.error("공장 삭제 실패:", e);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white w-[900px] max-w-[95vw] rounded-xl shadow-xl p-5">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold">
            공장 관리 — {company?.name}
          </h3>
          <button
            onClick={onClose}
            className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300"
          >
            닫기
          </button>
        </div>

        <div className="mb-4 border rounded-lg p-3 bg-gray-50">
          <div className="font-semibold mb-2">
            {factoryNew.id ? "공장 정보 수정" : "공장 추가 등록"}
          </div>
          <div className="gap-2 items-center">
            <FactoryRow
              row={factoryNew}
              idx={0}
              newCompany={company}
              setFactoryRows={setFactoryNew}
              onChangeFactoryRow={onChangeFactoryNewForRow}
              isModal={true}
            />
            {factoryNew.id ? (
              <button
                type="button"
                onClick={async () => {
                  await updateFactory(factoryNew.id, { ...factoryNew, company: company.id });
                  setFactoryNew({ name: "", address: "", detail_address: "", extra_address: "" });
                  setFactoryEditId(null);
                  await reloadFactoryList();
                }}
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
              >
                저장
              </button>
            ) : (
              <button
                type="button"
                onClick={addFactoryInModal}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
              >
                추가
              </button>
            )}
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-300 text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="border px-2 py-1">ID</th>
                <th className="border px-2 py-1">공장명</th>
                <th className="border px-2 py-1">주소</th>
                <th className="border px-2 py-1">상세 주소</th>
                <th className="border px-2 py-1">추가 주소</th>
                <th className="border px-2 py-1">관리</th>
              </tr>
            </thead>
            <tbody>
              {factoryList.map((f) => (
                <tr key={f.id} className="hover:bg-gray-50">
                  <td className="border px-2 py-1">{f.id}</td>
                  <td className="border px-2 py-1">{f.name}</td>
                  <td className="border px-2 py-1">{f.address}</td>
                  <td className="border px-2 py-1">{f.detail_address}</td>
                  <td className="border px-2 py-1">{f.extra_address}</td>
                  <td className="border px-2 py-1">
                    <div className="flex gap-2">
                      <button
                        onClick={() => setFactoryNew({ ...f })}
                        className="bg-yellow-500 hover:bg-yellow-600 text-white px-2 py-1 rounded"
                      >
                        수정
                      </button>
                      <button
                        onClick={() => removeFactory(f.id)}
                        className="bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded"
                      >
                        삭제
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {factoryList.length === 0 && (
                <tr>
                  <td className="text-center py-3" colSpan={6}>
                    해당 회사에 등록된 공장이 없습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FactoryModal;